import { t } from "ttag";

import { useSetting } from "metabase/common/hooks";
import type { PaletteSubPath } from "metabase/palette/types";
import { PLUGIN_AI_CONTROLS, PLUGIN_AUDIT } from "metabase/plugins";

// Mirrors MetabotNavPane's own sub-page list and visibility conditions
// (frontend/src/metabase/admin/ai/MetabotNavPane.tsx) so every sub-page
// reachable by browsing Admin > AI's sidebar is also reachable by name from
// the global command palette -- only the top-level "/admin/metabot" was
// searchable before this (WCAG 2.4.5 Multiple Ways).
export const useAiAdminPaths = (): PaletteSubPath[] => {
  const areAiFeaturesEnabled = useSetting("ai-features-enabled?") !== false;
  const aiControlsPaths = PLUGIN_AI_CONTROLS.getAiControlsPaths();
  const metabotAnalyticsPaths = PLUGIN_AUDIT.getMetabotAnalyticsPaths();

  const paths: (PaletteSubPath | null)[] = [
    areAiFeaturesEnabled
      ? {
          key: "ai-mcp-settings",
          name: `${t`AI`} - ${t`MCP`} - ${t`Settings`}`,
          path: "/admin/metabot/mcp",
        }
      : null,
    areAiFeaturesEnabled
      ? {
          key: "ai-mcp-authorizations",
          name: `${t`AI`} - ${t`MCP`} - ${t`Authorizations`}`,
          path: "/admin/metabot/mcp/authorizations",
        }
      : null,
  ];

  return [
    ...paths.filter((path): path is PaletteSubPath => path !== null),
    ...aiControlsPaths,
    ...metabotAnalyticsPaths,
  ];
};
